






































  import { Component, Prop, Vue } from 'vue-property-decorator';

  import { designStore } from '@/store/store';
  import AcOverlayConditionSurvey from '@/modules/design/views/acOverlay/components/AcOverlayConditionSurvey.vue';
  import InputPageWrapper from '@/views/components/input/InputPageWrapper.vue';
  import {
    IAcOverlayDesignImperial,
    IAcOverlayDesignMetric,
    StructuralEvaluationMethods,
  } from '@/modules/design/interfaces/acOverlay';
  import NonDestructiveTesting from '@/modules/design/views/acOverlay/components/NonDestructiveTesting.vue';
  import { maxValue, minValue, required } from 'vuelidate/lib/validators';
  import { Route } from 'vue-router';
  import ValidatedInputPageWrapper from '@/views/components/input/ValidatedInputPageWrapper.vue';
  import { createAcOverlayValidations } from '@/modules/design/lib/validations/acOverlay';

  Component.registerHooks(['validations']);

@Component({
  components: {
    ValidatedInputPageWrapper,
    AcOverlayConditionSurvey,
    NonDestructiveTesting,
    InputPageWrapper,
  },
})
  export default class AcOverlayStructuralEvaluation extends Vue {
  @Prop() readonly pxDesignId!: string;

  @Prop() readonly page!: number;

  get scenario(): IAcOverlayDesignImperial | IAcOverlayDesignMetric {
    return designStore.currentAcOverlay;
  }

  get scenarioImperial(): IAcOverlayDesignImperial {
    return designStore.currentAcOverlayImperial;
  }

  beforeRouteLeave(to: Route, from: Route, next: Function) {
    this.save();
    next();
  }

  get numLayers() {
    // Required for validating whether the user has created any layers.
    return this.scenarioImperial.existingLayers.length;
  }

  structuralEvaluationMethods = StructuralEvaluationMethods;

  validations() {
    return createAcOverlayValidations(this.scenarioImperial, this.scenario.unitSystem);

    //
    // Validators for items shared by both evaluation methods
    //
    // const validationObject: any = {
    //   scenarioImperial: {
    //     coresTaken: {
    //       required,
    //     },
    //
    //     millRemoveDistressed: {
    //       required,
    //     },
    //
    //   },
    // };
    //
    // /*
    //
    // The display layer uses the existence of these validators to control display of the inputs.
    //
    //  */
    //
    // if (this.scenarioImperial.millRemoveDistressed === true) {
    //   validationObject.scenarioImperial.removeDepth_in = {
    //     required,
    //     minValue: minValue(0),
    //   };
    //
    //   if (this.scenarioImperial.structuralEvaluationMethod === StructuralEvaluationMethods.testing) {
    //     validationObject.scenarioImperial.estimatedStructuralCoefficient = {
    //       required,
    //       minValue: minValue(0.05),
    //       maxValue: maxValue(0.5),
    //     };
    //   }
    // }
    //
    // //
    // // If cores taken, add validators
    // //
    // if (this.scenarioImperial.coresTaken === true) {
    //   const coreValidators: any = {
    //     crackCoresTaken: {
    //       required,
    //     },
    //     stripping: {
    //       required,
    //     },
    //   };
    //
    //   //
    //   // Crack Cores
    //   //
    //   if (this.scenarioImperial.crackCoresTaken === true) {
    //     // If crack cores, which type of cracks?
    //     coreValidators.topDownCracking = {
    //       required,
    //     };
    //     // If top down only, how deep?
    //     if (this.scenarioImperial.topDownCracking === 'Top-Down Only') {
    //       coreValidators.crackDepth_in = {
    //         required,
    //         minValue: minValue(0),
    //       };
    //     }
    //   }
    //
    //   //
    //   // Stripping
    //   //
    //   if (this.scenarioImperial.stripping === true) {
    //     coreValidators.distressDepth_in = {
    //       required,
    //       minValue: minValue(0),
    //     };
    //   }
    //
    //   Object.assign(validationObject.scenarioImperial, coreValidators);
    // }
    //
    // if (this.scenario.structuralEvaluationMethod === StructuralEvaluationMethods.survey) {
    //   const surveyValidators = {
    //     alligatorLow: {
    //       required,
    //     },
    //     alligatorMed: {
    //       required,
    //     },
    //     alligatorHigh: {
    //       required,
    //     },
    //     transverseLow: {
    //       required,
    //     },
    //     transverseMed: {
    //       required,
    //     },
    //     transverseHigh: {
    //       required,
    //     },
    //   };
    //   Object.assign(validationObject.scenarioImperial, surveyValidators);
    // } else if (this.scenario.structuralEvaluationMethod === StructuralEvaluationMethods.testing) {
    //   const testingValidators = {
    //     combinedLayerStiffness: {
    //       required,
    //       minValue: minValue(0),
    //     },
    //     designSubgradeModulus_psi: {
    //       required,
    //       minValue: minValue(0),
    //     },
    //     estimatedStructuralCoefficient: {
    //       minValue: minValue(0.05),
    //       maxValue: maxValue(0.5),
    //     },
    //   };
    //
    //   Object.assign(validationObject.scenarioImperial, testingValidators);
    // }
    // return validationObject;
  }

  save() {
    this.sync();
    designStore.saveCurrentAcOverlayScenario();
  }

  sync() {
    console.log('AcPage4 Sync');

    designStore.setCurrentAcOverlayScenario(this.scenario);
  }
  }


